import { render, staticRenderFns } from "./entruckDetails.vue?vue&type=template&id=69ac8ab4&scoped=true&"
import script from "./entruckDetails.vue?vue&type=script&lang=js&"
export * from "./entruckDetails.vue?vue&type=script&lang=js&"
import style0 from "./entruckDetails.vue?vue&type=style&index=0&id=69ac8ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ac8ab4",
  null
  
)

export default component.exports